export const createCurrencyRatesRepository = (appFetch) => {
    return {
        internet(params = {}) {
            return appFetch.get('/api/v1/currency/card-rates', {params});
        },
        office(params = {}) {
            return appFetch.get('/api/v1/currency/rates', {params});
        },
        other(params = {}) {
            return appFetch.get('/api/v1/currency/card-rates/pl', {params});
        },
        internetArchive(params = {}) {
            return appFetch.get('/api/v1/currency/card-rates/archive', {params});
        },
        officeArchive(params = {}) {
            return appFetch.get('/api/v1/currency/rates/archive', {params});
        },
        otherArchive(params = {}) {
            return appFetch.get('/api/v1/currency/card-rates/pl/archive', {params});
        },
    };
};
